
// Production Client ID and Client Secret
const CLIENT_ID = "id-bb4aeb8a-e476-5cfe-3346-4e0bde719d6";
const CLIENT_SECRET = "secret-5a51426a-2f44-66ae-cc3e-b93d43ce05f";

export async function getAccessToken() {
  try {
    const response = await fetch("/o/oauth2/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        grant_type: "client_credentials",
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to get token: ${response.status}`);
    }

    const data = await response.json();
    return data.access_token;
  } catch (error) {
    console.error("Error fetching access token:", error);
    return null;
  }
}

export async function getLiferayApiHeadersAsync() {
  const base = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  const signedIn = Boolean(window.Liferay?.ThemeDisplay?.isSignedIn?.());
  if (signedIn) {
    return {
      ...base,
      "x-csrf-token": window.Liferay?.authToken || "",
    };
  }

  return base;
}

export async function getLiferayFetchInit(baseInit = {}) {
  const headers = await getLiferayApiHeadersAsync();
  return {
    ...baseInit,
    headers: { ...headers, ...(baseInit.headers || {}) },
    credentials:
      baseInit.credentials !== undefined ? baseInit.credentials : "include",
  };
}

export async function getBearerTokenForGuestApis() {
  return getAccessToken();
}


export function redirectToLiferayLogin(returnUrl) {
  const target = returnUrl || window.location.href;
  const loginPath = process.env.REACT_APP_LOGIN_PATH || "/c/portal/login";
  const normalized = loginPath.startsWith("/") ? loginPath : `/${loginPath}`;
  window.location.href = `${window.location.origin}${normalized}?redirect=${encodeURIComponent(target)}`;
}

export function isLiferaySignedIn() {
  return Boolean(window.Liferay?.ThemeDisplay?.isSignedIn?.());
}
